import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { taxSettingsActions } from './tax-settings.actions'
import { catchError, map, of, switchMap } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { TaxSettingsService } from '../../services/tax-settings.service'

// Load all financial years
export const loadFinancialYears$ = createEffect(
  (
    actions$ = inject(Actions),
    taxSettingsService = inject(TaxSettingsService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(taxSettingsActions.loadFinancialYears),
      switchMap(() =>
        taxSettingsService.loadFinancialYears().pipe(
          map(financialYears => taxSettingsActions.loadFinancialYearsSuccess({ financialYears })),
          catchError(error => {
            toastr.error(error.error.message)
            return of(taxSettingsActions.loadFinancialYearsFailure({ error: error.message }))
          })
        )
      )
    ),
  { functional: true }
)

// Load tax settings
export const loadTaxSettings$ = createEffect(
  (
    actions$ = inject(Actions),
    taxSettingsService = inject(TaxSettingsService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(taxSettingsActions.loadSlabsAndRules),
      switchMap(({ date }) =>
        taxSettingsService.loadSlabsAndRules(date).pipe(
          map(fyTaxSettings => taxSettingsActions.loadSlabsAndRulesSuccess({ fyTaxSettings })),
          catchError(error => {
            toastr.error(error.error.message)
            return of(taxSettingsActions.loadSlabsAndRulesFailure({ error: error.message }))
          })
        )
      )
    ),
  { functional: true }
)

export const taxSettingsEffects = {
  loadFinancialYears$,
  loadTaxSettings$
}
